<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-update-class-school"
            @hidden="resetModal">

            <div class="container wrap-form-create-update-chapter">
                <h4>
                    <strong>{{ getNameTitle }}</strong>
                </h4>
                <b-form id="form-create-update-chapter" @submit.prevent="handleSave">
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Tên chương:</label>
                                <b-form-input id="name" v-model="form.name" type="text" placeholder="Nhập tên chương"
                                    autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.name.required && submitted">
                                    Vui lòng nhập tên chương
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form_action display-flex justity-content-center cg-1">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isDisabled">
                            {{ chapterId > 0 ? 'Cập nhật' : 'Thêm mới' }}
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import { saveChapterClassSchool,getDetail } from './../../../_api/chapterClassSchoolServices'
export default {
    props: {
        chapterId: {
            type: Number,
            default: 0
        },
        type: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            isDisabled:false,
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                id: 0,
                lessonClassSchoolId:0,
                name: ''
            }
        }
    },
    validations() {
        return {
            form: {
                name: {
                    required
                },
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle() {
            return this.chapterId==0?'Tạo chương':'Cập nhật chương'
        }
    },
    mounted() {
        this.form.lessonClassSchoolId = this.$route.query.id
        if(this.chapterId >0){
            //get detail
            this.getDetailChapterClassSchool()
        }
        this.handleShowModal()
    },
    methods: {
        getDetailChapterClassSchool(){
            let self = this
            getDetail(this.chapterId).then(res => {
                if (res && res.data && !res.errors) {
                    self.form = {
                        id:res.data.id,
                        lessonClassSchoolId: res.data.lessonClassSchoolId,
                        name: res.data.name,
                    }
                }
            })
        },
        handleSave() {
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
                self.isDisabled = true
                saveChapterClassSchool(this.form).then(res => {
                    if (res && res.data && !res.errors) {
                        if (this.form.id > 0) {
                            self.$toast.success('Cập nhật chương thành công')
                        } else {
                            self.$toast.success('Thêm mới chương thành công')
                        }

                        self.handleDone()
                    }
                    self.isDisabled = false
                })
            }
        },
        resetModal() {
            this.submitted = false
            this.form = {
                id: 0,
                name: ''
            }
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-create-update-class-school'].show()
        },
    }
}
</script>
<style lang="scss">
.wrap-form-create-update-chapter {
    background-color: white;
}

.justify-content-space-between {
    justify-content: space-between
}
.justity-content-center {
    justify-content: center
}
.cg-1 {
    column-gap: 1rem;
}
</style>
